export function ChartLegendItem({
  color,
  label,
  shape,
}: {
  color: string;
  label: string;
  shape: "line" | "block" | "divider";
}) {
  const swatchShape = {
    line: "w-4 h-0.5 rounded",
    block: "w-3 h-3 rounded-sm",
    divider: "w-0.5 h-3.5 rounded",
  }[shape];

  return (
    <span className={"flex items-center gap-1.5 text-xs text-slate-500"}>
      <span className={swatchShape} style={{ backgroundColor: color }} />
      {label}
    </span>
  );
}
